export default [

  {
    path: '/cyzsArticle/articleList',
    name: 'articleList',
    meta: {
      title: '全部动态'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/articleList/main.vue'], resolve)
    }
  },
  {
    path: '/cyzsArticle/articleEdit',
    name: 'articleEdit',
    meta: {
      title: '编辑内容'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/articleList/articleEdit.vue'], resolve)
    }
  },
  {
    path: '/cyzsArticle/articleGoods',
    name: 'articleGoods',
    meta: {
      title: '同款单品'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/articleList/articleGoods.vue'], resolve)
    }
  },
  {
    path: '/cyzsArticle/articleSimilaryGoods',
    name: 'articleSimilaryGoods',
    meta: {
      title: '相似商品'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/articleList/articleSimilaryGoods.vue'], resolve)
    }
  },
  {
    path: '/cyzsArticle/similaryGoods',
    name: 'similaryGoods',
    meta: {
      title: '相似商品列表'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/similaryGoods/main.vue'], resolve)
    }
  },
  {
    path: '/cyzsArticle/catchPriceSetting',
    name: 'catchPriceSetting',
    meta: {
      title: '抓取价格设置'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/similaryGoods/catchPriceSetting.vue'], resolve)
    }
  },
  {
    path: '/cyzsArticle/iconManage/iconList',
    name: 'cyzsIcon',
    meta: {
      title: 'ICON管理'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/iconManage/main.vue'],resolve)
    }
  },
  {
    path: '/cyzsArticle/iconManage/editIcon',
    name: 'editIcon',
    meta: {
      title: '编辑Icon'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/iconManage/editIcon.vue'],resolve)
    }
  },
  {
    path: '/cyzsArticle/tagManage/tagList',
    name: 'tagManage',
    meta: {
      title: '标签管理'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/tagManage/main.vue'],resolve)
    }
  },
  {
    path: '/cyzsArticle/iconManage/sourceManage',
    name: 'sourceManage',
    meta: {
      title: '内容源管理'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/iconManage/sourceManage.vue'],resolve)
    }
  },
  {
    path: '/cyzsArticle/iconManage/priorityProductSource',
    name: 'priorityProductSource',
    meta: {
      title: '优先商品源管理'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/iconManage/priorityProductSource.vue'],resolve)
    }
  },
  {
    path: '/cyzsArticle/iconManage/editIconCategory',
    name: 'editIconCategory',
    meta: {
      title: '编辑Icon分类'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/iconManage/editIconCategory.vue'],resolve)
    }
  },
  {
    path: '/cyzsArticle/pictureAudit',
    name: 'pictureAudit',
    meta: {
      title: '图片审核'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/pictureAudit/main.vue'],resolve)
    }
  },
  {
    path: '/cyzsArticle/pictureSettings',
    name: 'pictureSettings',
    meta: {
      title: '查看区块'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/pictureAudit/pictureSettings.vue'],resolve)
    }
  },
  {
    path: '/cyzsArticle/votingContentLibrary',
    name: 'votingContentLibrary',
    meta: {
      title: '投票内容库'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsArticle/votingContentLibrary/main.vue'],resolve)
    }
  },
]